export default __webpack_public_path__ + "static/media/logo-white-resize.b50627e1.png";